import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-trigger',
  templateUrl: './trigger.component.html',
  styleUrls: ['./trigger.component.scss'],
})
export class TriggerComponent implements OnInit {
  @Input() state: boolean;

  @Output() Change: EventEmitter<any> = new EventEmitter<any>();

  iconCircle = faCircle;

  constructor() {}

  ngOnInit() {}

  trigger() {
    this.state = !this.state;
    this.Change.emit(this.state);
  }
}
